import { EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import { type Tenant } from 'types/shopConfig'

type GetExtendedQuerySuggestionParametersReturnType = {
  showRatings: boolean
  showReducedPrice: boolean
  showDiscountBubble: boolean
}

export const getExtendedQuerySuggestionParameters = (
  variant: EXPERIMENT_VARIATION
): GetExtendedQuerySuggestionParametersReturnType => {
  switch (variant) {
    case EXPERIMENT_VARIATION.DEFAULT:
      return {
        showRatings: false,
        showReducedPrice: false,
        showDiscountBubble: false,
      }
    case EXPERIMENT_VARIATION.V1:
      return {
        showRatings: true,
        showReducedPrice: false,
        showDiscountBubble: false,
      }

    case EXPERIMENT_VARIATION.V2:
      return {
        showRatings: false,
        showReducedPrice: true,
        showDiscountBubble: false,
      }

    case EXPERIMENT_VARIATION.V3:
      return {
        showRatings: false,
        showReducedPrice: true,
        showDiscountBubble: true,
      }

    case EXPERIMENT_VARIATION.V4:
      return {
        showRatings: true,
        showReducedPrice: true,
        showDiscountBubble: false,
      }

    case EXPERIMENT_VARIATION.V5:
      return {
        showRatings: true,
        showReducedPrice: true,
        showDiscountBubble: true,
      }

    default:
      return {
        showRatings: false,
        showReducedPrice: false,
        showDiscountBubble: false,
      }
  }
}

export const getLegalSupNumberForTenant = (tenant: Tenant) => {
  switch (tenant) {
    case 'at':
      return '2'
    case 'com':
      return '1'
    default:
      return ''
  }
}
